export default __webpack_public_path__ + "static/media/markerwhite.9f64bce5.svg";